import React from "react";
import { Send, Mail, ExternalLink } from "lucide-react";
import { usePartner } from "@/context/PartnerContext";
import { useSiteContent } from "@/context/SiteContentContext";

// Support contact for the current shop: the partner's own on a white-label shop, else Admin → Content.
export const useSupport = () => {
  const { partner, isPartner, brand } = usePartner();
  const content = useSiteContent()?.content || {};
  const src = isPartner ? partner || {} : content;
  const telegram = (src.support_telegram || "").replace(/^@/, "");
  const email = src.support_email || "";
  const url = src.support_url || "";
  return { telegram, email, url, any: Boolean(telegram || email || url), brandName: brand.name };
};

export const SupportLinks = ({ compact = false, className = "" }) => {
  const s = useSupport();
  if (!s.any) return null;
  const item = "inline-flex items-center gap-1.5 hover:underline";
  return (
    <div className={`flex flex-wrap items-center gap-x-4 gap-y-1.5 ${compact ? "text-xs" : "text-sm"} ${className}`} data-testid="support-links">
      {s.telegram && <a href={`https://t.me/${s.telegram}`} target="_blank" rel="noopener noreferrer" className={item} data-testid="support-telegram"><Send className="h-3.5 w-3.5" /> @{s.telegram}</a>}
      {s.email && <a href={`mailto:${s.email}`} className={item} data-testid="support-email"><Mail className="h-3.5 w-3.5" /> {s.email}</a>}
      {s.url && <a href={s.url} target="_blank" rel="noopener noreferrer" className={item} data-testid="support-url"><ExternalLink className="h-3.5 w-3.5" /> Contact page</a>}
    </div>
  );
};

// "Need help with your order?" box for order status / tracking pages.
export const SupportBox = () => {
  const s = useSupport();
  if (!s.any) return null;
  return (
    <div className="mt-6 border border-border bg-card p-4" data-testid="support-box">
      <div className="mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">Need help with your order?</div>
      <p className="mt-1 text-sm text-muted-foreground">Contact <span className="text-foreground">{s.brandName}</span> support — quote your Order ID.</p>
      <SupportLinks className="mt-2" />
    </div>
  );
};
